import {derived} from 'svelte/store'
import {filterSettings} from "$lib/stores/filterSettings.js";

export const filtered = derived(filterSettings,
    $filterSettings => {
        return !Object.entries($filterSettings)
        .filter(([key, _]) => key !== 'search' && key !== 'sortAlph')
        .every(([_, prop]) => prop === '' || prop === false)
    }
)